import { useRegisterVerify } from "../api/api";
import { Spin } from "antd";
import { CircleX } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function RegisterVerifyPage() {
  const [searchParams] = useSearchParams();

  const cid = searchParams.get("cid");
  const key = searchParams.get("key");

  const { mutateAsync, isPending } = useRegisterVerify();
  const [errorMsg, setErrorMsg] = useState<string>();
  const navigate = useNavigate();

  useEffect(() => {
    if (cid === undefined || key === undefined) return;

    if (!cid || !key) {
      navigate("/login", { replace: true });
      return;
    }

    mutateAsync({ cid, regkey: key })
      .then(() => {
        navigate("/login?register=success");
      })
      .catch((err) => {
        const message =
          err.response?.data?.message ||
          "Sorry! Something went wrong. Please try again.";
        setErrorMsg(message);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cid, key]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center px-6 py-12">
      {isPending && <Spin size="large" />}
      {errorMsg && (
        <div className="border border-red-300 bg-red-300/10 p-4 rounded-lg flex items-center text-sm gap-2">
          <CircleX className="text-red-400" />
          The registration link might have expired or is invalid. Please try to
          re-register.
        </div>
      )}
    </div>
  );
}
